import Select from '@mui/material/Select';
import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

const LoupeSelectionComponent = props => {

    const callbackHandler = props.callbackHandler;
    
    const currentItem = props.currentItem;
    const componentLabel = currentItem.label + (currentItem.required ? '*' : '');


    const [ selectedValue, setSelectedValue ] = useState(currentItem.selectedValue);

    const handleChange = (event) => {
        currentItem.selectedValue = event.target.value;
        setSelectedValue(event.target.value);

        currentItem.validator.touched();
        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }
        
      };
    

    return(

        <div className="text-start mb-4">
            <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                <InputLabel>{componentLabel}</InputLabel>
                <Select fullWidth
                    value={selectedValue} 
                    onChange={handleChange}
                    label={componentLabel}>
                    { currentItem['choices'].map(c => {
                        return(
                            <MenuItem value={c['_attributes']['export-label']} key={c['_attributes']['export-label']}>{c['_attributes']['label']}</MenuItem>
                        );
                    })}
                </Select>
               
            </FormControl>
        </div>
    )

}
export default LoupeSelectionComponent;
